import { render, staticRenderFns } from "./BlueCheck.vue?vue&type=template&id=fa54b504&"
import script from "./BlueCheck.vue?vue&type=script&lang=js&"
export * from "./BlueCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports